import miniToastr from 'mini-toastr';

export default {

    axiosCatch(error) {
        // If this is a 419 (CSRF token error) do a page reload
        if (error.response && error.response.status === 419) {
            miniToastr.error('Session timed-out, reloading...', '', 30000);
            setTimeout('location.reload();', 4000);
            return false;
        }

        console.log(error);

        // Surface server-provided error message if present (e.g. 422 validation)
        let msg = error.message;
        if (error.response && error.response.data) {
            if (error.response.data.error) {
                msg = error.response.data.error;
            } else if (error.response.data.message) {
                msg = error.response.data.message;
            }
        }
        miniToastr.error(msg, '', 30000);
    },

    axiosThen(response) {
        if (typeof response === "undefined" || typeof response.data === "undefined") {
            return response;
        }
        if (typeof response.data.error !== "undefined") {
            miniToastr.error(response.data.error, '', 30000);
        }
        if (typeof response.data.errors !== "undefined") {
            _.forEach(response.data.errors, function(error) {
                miniToastr.error(error, '', 30000);
            })
        }
        if (typeof response.data.success !== "undefined") {
            miniToastr.success(response.data.success, '', 3000);
        }
        return response.data;
    },

    responseHasErrors(responseData) {
        if (typeof responseData === "undefined")
            return true;

        return typeof responseData.errors !== "undefined"
            && typeof responseData.errors.length !== "undefined"
            && responseData.errors.length > 0;
    },

    printerStatus() {
        return window.axios.get('/printers/status')
            .then(response => response.data)
            .catch(() => ({ online: false }));
    },

    printLabel(type, id, quantity) {
        return window.axios.post(`/checklist/print-label`, {
            type: type,
            id: id,
            quantity: quantity,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    updateChecklist(type, id, checked, workcentre_id, user_id) {
        return window.axios.put(`/checklist`, {
            type: type,
            id: id,
            checked: checked,
            workcentre_id: workcentre_id,
            user_id: user_id,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    updateNumPeopleRequired(id, num_people) {
        return window.axios.put(`/checklist/num-people`, {
            id: id,
            num_people: num_people,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    updateProcessEstSeconds(id, minutes) {
        return window.axios.put(`/checklist/est-seconds`, {
            id: id,
            minutes: minutes,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    addChecklistProcess(item_id, process_name, workcentre_id, minutes, num_people) {
        return window.axios.post(`/checklist/process`, {
            item_id: item_id,
            process_name: process_name,
            workcentre_id: workcentre_id,
            minutes: minutes,
            num_people: num_people,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getChecklistWorkcentres() {
        return window.axios.get(`/checklist/workcentres`)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    updateProcessUserTime(id, user_id, datetime, from_user_id) {
        let data = { id: id, user_id: user_id, datetime: datetime };
        if (from_user_id) data.from_user_id = from_user_id;
        return window.axios.put(`/checklist/usertime`, data)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    toggleItemAssignment(item_id, calendar_item_id, user_id) {
        return window.axios.put(`/checklist/toggle-assignment`, {
            item_id: item_id,
            calendar_item_id: calendar_item_id,
            user_id: user_id,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getChecklistItems(year, week_num, workcentre_id, user_id) {
        return window.axios.get(`/checklist/${year}/${week_num}`, {
            params: {
                format: 'json',
                workcentre_id: workcentre_id,
                user_id: user_id,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getProductionHistory(year, week_num) {
        return window.axios.get(`/history/${year}/${week_num}`, {
            params: {
                format: 'json',
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getProductionHistoryUsersCompleted(user_id, start_date, end_date) {
        return window.axios.get(`/history/users-completed`, {
            params: {
                user_id: user_id,
                start_date: start_date,
                end_date: end_date,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getWorkcentreDashboard(year, week_num) {
        return window.axios.get(`/workcentre-dashboard/${year}/${week_num}?format=json`)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    getProductionStats(timeSpan, timeUnit, userIDs, processTags) {
        return window.axios.get('/api/production-stats', {
            params: {
                timeSpan: timeSpan,
                timeUnit: timeUnit,
                userIDs: userIDs,
                processTags: processTags,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getProductionDashboardData() {
        return window.axios.get('/api/pd').catch(this.axiosCatch).then(this.axiosThen);
    },

    getBatches(user_id=null, item_id=null, quote_id=null, status=null, process_name=null, assigned='') {
        return window.axios.get('/progress/table/batches', {
            params: {
                user_id: user_id ? user_id : '',
                item_id: item_id ? item_id : '',
                quote_id: quote_id ? quote_id : '',
                status: status ? status : '',
                process_name: process_name ? process_name : '',
                assigned: assigned,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getItems(user_id=null, item_id=null, quote_id=null, status=null, process_name=null, assigned='') {
        return window.axios.get('/progress/table/items', {
            params: {
                user_id: user_id ? user_id : '',
                item_id: item_id ? item_id : '',
                quote_id: quote_id ? quote_id : '',
                status: status ? status : '',
                process_name: process_name ? process_name : '',
                assigned: assigned,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getProcesses(user_id=null, item_id=null, quote_id=null, status=null, process_name=null, assigned='') {
        return window.axios.get('/progress/table/processes', {
            params: {
                user_id: user_id ? user_id : '',
                item_id: item_id ? item_id : '',
                quote_id: quote_id ? quote_id : '',
                status: status ? status : '',
                process_name: process_name ? process_name : '',
                assigned: assigned,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    delete(ids=[], type='processes') {
        return type === 'items'
            ? this.deleteItems(ids)
            : this.deleteWork(ids);
    },

    deleteWork(work_ids=[]) {
        return window.axios.delete('/progress/table/processes', {
            data: { ids: work_ids }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    deleteItems(item_ids=[]) {
        return window.axios.delete('/progress/table/items', {
            data: { ids: item_ids }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    ping() {
        return window.axios.get('/ping')
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    updateWorkStatus(work_id, status) {
        return window.axios.put(`/work/${work_id}`, {
            status: status,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    updateBatchStatus(hash, status, user_id) {
        return window.axios.put(`/progress/table/batches/${hash}`, {
            status: status,
            user_id: user_id,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    batchCreate(ids=[], id_type='processes', individually=false) {
        return window.axios.post('progress/table/batches', {
            ids: ids,
            id_type: id_type,
            individually: individually,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    unbatch(ids=[], id_type='processes') {
        return window.axios.delete('progress/table/batches', {
            data: {
                ids: ids,
                id_type: id_type,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    assign(user_id, ids=[], type='processes') {
        if (type === 'batches')
            return this.assignBatches(user_id, ids);
        if (type === 'items')
            return this.assignItems(user_id, ids);
        if (type === 'processes')
            return this.assignWork(user_id, ids);
    },

    unassign(user_id, ids=[], type='processes') {
        if (type === 'batches')
            return this.unassignBatches(user_id, ids);
        if (type === 'items')
            return this.unassignItems(user_id, ids);
        if (type === 'processes')
            return this.unassignWork(user_id, ids);
    },

    assignWork(user_id, work_ids=[]) {
        return window.axios.post('progress/work/assignment', {
            user_id: user_id,
            ids: work_ids,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    unassignWork(user_id, work_ids=[]) {
        return window.axios.delete('progress/work/assignment', {
            data: {
                user_id: user_id,
                ids: work_ids,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    assignItems(user_id, item_ids=[]) {
        return window.axios.post('progress/item/assignment', {
            user_id: user_id,
            ids: item_ids,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    unassignItems(user_id, item_ids=[]) {
        return window.axios.delete('progress/item/assignment', {
            data: {
                user_id: user_id,
                ids: item_ids,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    assignBatches(user_id, hashes=[]) {
        return window.axios.post('progress/batch/assignment', {
            user_id: user_id,
            hashes: hashes,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    unassignBatches(user_id, hashes=[]) {
        return window.axios.delete('progress/batch/assignment', {
            data: {
                user_id: user_id,
                hashes: hashes,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    createIssue(work_id, reason_id, message='') {
        return window.axios.post('/issues', {
            work_id: work_id,
            reason_id: reason_id,
            message: message,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getScribbles(item_id, type='') {
        return window.axios.get(`/item/${item_id}/production-sheet/scribbles`, {
            params: { type: type }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    saveScribble(item_id, data_uri) {
        return window.axios.post(`/item/${item_id}/production-sheet/scribbles`, {
            data_uri: data_uri,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    stampMeasured(item_id) {
        return window.axios.post(`/item/${item_id}/production-sheet/measured`)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    uploadScribblePhoto(item_id, photo) {
        let formData = new FormData();
        formData.append('photo', photo);

        return window.axios.post(`/item/${item_id}/production-sheet/scribbles`, formData)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    deleteScribble(item_id, scribble_id, type='') {
        return window.axios.delete(`/item/${item_id}/production-sheet/scribbles/${scribble_id}`, {
            data: { type: type }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    loadPrinters(filter='') {
        return window.axios.get(`/printers`, {
            params: {
                format: 'json',
                filter: filter,
            }
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    updatePrinters(dymoPrinters) {
        return window.axios.post(`/printers`, {
            dymoPrinters: dymoPrinters,
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

    getLabel(type, id) {
        return window.axios.get(`/label/${type}/${id}`)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    aiCreateSession() {
        return window.axios.post('/ai-draft/sessions')
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    aiListSessions() {
        return window.axios.get('/ai-draft/sessions')
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    aiGetSession(id) {
        return window.axios.get(`/ai-draft/sessions/${id}`)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    aiSendMessage(id, content) {
        return window.axios.post(`/ai-draft/sessions/${id}/messages`, { content: content })
            .catch(this.axiosCatch).then(this.axiosThen);
    },

/**
     * Stream a user message and consume Server-Sent Events from the runner.
     * Resolves with the final {sessionUpdate, error, stopReason} once the
     * `complete` event lands; calls onEvent(type, data) for every event so
     * the UI can render text deltas and tool calls as they happen.
     *
     * Unlike axios methods this returns a plain Promise; rejection means
     * the network or HTTP layer failed. Server-side runner errors arrive
     * as a normal `error` SSE event followed by `complete`.
     */
    async aiStreamMessage(id, content, onEvent) {
        const csrfMeta = document.head.querySelector('meta[name="csrf-token"]');
        const csrf = csrfMeta ? csrfMeta.content : '';

        const response = await fetch(`/ai-draft/sessions/${id}/messages/stream`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/event-stream',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrf,
            },
            body: JSON.stringify({ content: content }),
        });

        if (!response.ok || !response.body) {
            const text = await response.text().catch(() => '');
            const err = new Error(`Stream failed: ${response.status} ${response.statusText}` + (text ? ` — ${text.slice(0, 200)}` : ''));
            err.status = response.status;
            throw err;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let outcome = { sessionUpdate: null, error: null, stopReason: null };

        const drainEvents = () => {
            let sep;
            while ((sep = buffer.indexOf('\n\n')) >= 0) {
                const raw = buffer.slice(0, sep);
                buffer = buffer.slice(sep + 2);
                if (raw.startsWith(':')) continue; // SSE comment / padding

                let eventType = null;
                const dataLines = [];
                for (const line of raw.split('\n')) {
                    if (line.startsWith('event: ')) eventType = line.slice(7);
                    else if (line.startsWith('data: ')) dataLines.push(line.slice(6));
                }
                if (!eventType) continue;
                let data = {};
                try { data = dataLines.length ? JSON.parse(dataLines.join('\n')) : {}; }
                catch (e) { console.warn('Bad SSE data', dataLines, e); continue; }

                if (eventType === 'complete') {
                    outcome.stopReason = data.stop_reason || null;
                    if (data.error) outcome.error = data.error;
                } else if (eventType === 'error') {
                    outcome.error = data.message || 'Unknown stream error';
                } else if (eventType === 'session_update' && data.session) {
                    outcome.sessionUpdate = data.session;
                }
                try { onEvent(eventType, data); } catch (e) { console.error('onEvent threw', e); }
            }
        };

        try {
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                drainEvents();
            }
            buffer += decoder.decode(); // flush any final bytes
            drainEvents();
        } finally {
            try { reader.releaseLock(); } catch (e) {}
        }

        return outcome;
    },

    aiCompleteSession(id) {
        return window.axios.post(`/ai-draft/sessions/${id}/complete`)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    aiAbandonSession(id) {
        return window.axios.post(`/ai-draft/sessions/${id}/abandon`)
            .catch(this.axiosCatch).then(this.axiosThen);
    },

    aiUploadImage(id, file) {
        const form = new FormData();
        form.append('image', file);
        return window.axios.post(`/ai-draft/sessions/${id}/images`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).catch(this.axiosCatch).then(this.axiosThen);
    },

}